import {Component, OnInit, Inject, HostListener, Input, Output, EventEmitter} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { File } from '../../objects/file';
import {AppComponent} from "../../app.component";


@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
})
export class DeleteConfirmationComponent implements OnInit {

  // public target: File[] = [];
  // constructor(private dialogRef: MatDialogRef<DeleteConfirmationComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data
  // ) {
  //   this.target = data.target;
  // }

  @Input() application: AppComponent;
  @Input() state: string;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  ngOnInit() {
  }

  @HostListener('document:keydown', ['$event']) public onKeyDown($event: KeyboardEvent) {
    $event.stopPropagation();
    if ($event.key === 'Enter') {
      this.handleSubmit()
    }
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    //this.dialogRef.close({ isConfirmed: true })
    this.success.emit()
  }

}
